/* eslint-disable no-confusing-arrow */
/* eslint-disable no-param-reassign */
import { isDate } from 'aegion_common_utilities/lib/DateUtil';
import { M_D_YYYY } from 'aegion_common_utilities/lib/format/datetime';

const _isValidDate = date => isDate(date) && new Date(date) > new Date('01-01-2000') && new Date(date) <= new Date();

const computeYearDelta = (startDate, endDate) => {
  startDate = new Date(startDate);
	endDate = new Date(endDate);
	
	if (!isDate(startDate) || !isDate(endDate)) {
		return 0;
	}
    
  // Ensure the start date is before the end date, swap if necessary
  if (startDate > endDate) {
    [startDate, endDate] = [endDate, startDate];
  }

  const startYear = startDate.getFullYear();
  const startMonth = startDate.getMonth();
  const startDay = startDate.getDate();
  const endYear = endDate.getFullYear();
  const endMonth = endDate.getMonth();
  const endDay = endDate.getDate();

  let years = endYear - startYear;

  // Check if the anniversary date has not yet passed in the end year
  if (endMonth < startMonth || (endMonth === startMonth && endDay < startDay)) {
    years-=1;
  }

  return years;
}

const computeSurveySafeStartEnd = ({ start, end, yearDeltaThreshold = 0 }) => {
	// ignores future dates and invalid dates
	const safeStart = [start, end].filter(v => _isValidDate(v))[0];
	const safeEnd = [end, start].filter(v => _isValidDate(v))[0];

	// escape: invalid dates
	if (!isDate(safeStart) && !isDate(safeEnd)) {
		return {
			safeStart: undefined,
			safeEnd: undefined,
		}
	}

	// escape: invalid start date - we assume some incorrect start date: 1970, 2010, 2011, 2023
	const yearDelta = computeYearDelta(safeStart, safeEnd);
	if (yearDelta > yearDeltaThreshold) {
		return {
			safeStart: safeEnd,
			safeEnd,
		}
	}

	// success: found start end dates
	return {
		safeStart,
		safeEnd,
	};
}


export const computeSurveysStartEnd = ({ surveys = [], surveyYearDeltaThreshold = 0, surveysYearDeltaThreshold = 1 }) => {

	const safeSurveys = surveys.map(s => {
		const {
			safeStart: start,
			safeEnd: end
		} = computeSurveySafeStartEnd({
			start: s.start,
			end: s.end,
			yearDeltaThreshold: surveyYearDeltaThreshold
		});

		return {
			...s,
			start,
			end,
		}
	});

	const starts = safeSurveys.filter(s => _isValidDate(s.start)).map(s => new Date(s.start).getTime()).sort().map(v => M_D_YYYY(v));
	const ends = safeSurveys.filter(s => _isValidDate(s.end)).map(s =>  new Date(s.end).getTime()).sort().map(v => M_D_YYYY(v));

	const _end = isDate(ends.at(-1)) ? ends.at(-1) : starts.at(-1);
	const _start = [...starts, ...ends].sort().filter(v => isDate(_end) && isDate(v) && computeYearDelta(v, _end) <= surveysYearDeltaThreshold)[0];

	// escape: invalid dates
	if (!isDate(_start) && !isDate(_end)) {
		return {
			start: undefined,
			end: undefined
		}
	}

	const safeStart = [_start, _end].filter(v => _isValidDate(v))[0];
	const safeEnd = [_end, _start].filter(v => _isValidDate(v))[0];

	// escape: invalid start date - we assume some incorrect start date: 1970, 2010, 2011, 2023
	const yearDelta = computeYearDelta(safeStart, safeEnd);
	if (yearDelta > surveysYearDeltaThreshold) {
		return {
			start: safeEnd,
			end: safeEnd,
		}
	}
	
	// success: found valid dates
	return {
		start: safeStart,
		end: safeEnd,
	}
}


export default {
	computeYearDelta,
	computeSurveySafeStartEnd,
	computeSurveysStartEnd,
}